import calculateImageProxyPath from './calculateImageProxyPath';
import { DatapointStatus } from 'owa-analytics';
import loadImageFromSrc from './loadImageFromSrc';
import createImageProxyDatapoint, {
    ImageProxyEndpoint,
    ImageProxyTelemetryConfig,
} from './createImageProxyDatapoint';
import * as trace from 'owa-trace';

// Status code
const STATUS_CODE = 'statusCode';

// We want to capture perf for both model B and D for latency comparision

/**
 * Load an image from model B proxy -- connector proxy
 * @param img The image
 * @param shadowTraffic shadow traffic or not
 * @param telemetryConfig The telemetry config
 */
export default async function loadFromModelBProxy(
    img: HTMLImageElement,
    shadowTraffic: boolean,
    telemetryConfig: ImageProxyTelemetryConfig,
    delayRevoke: boolean
): Promise<boolean> {
    const modelBDatapoint = createImageProxyDatapoint(
        {
            endpoint: ImageProxyEndpoint.ModelB,
        },
        telemetryConfig
    );
    modelBDatapoint.addCustomProperty('isShadowTraffic', shadowTraffic);

    try {
        const modelBProxySrc = await calculateImageProxyPath(img);
        if (modelBProxySrc) {
            // In non-shadowing, load happens on real img. In shadowing, we create a temp un-attached img
            const modelBImage = shadowTraffic ? document.createElement('img') : img;
            const response = await loadImageFromSrc(modelBImage, modelBProxySrc, delayRevoke);
            modelBDatapoint.addCustomProperty(STATUS_CODE, response.status);
            if (response.status === 200) {
                modelBDatapoint.endWithSuccess();
                return true;
            } else if (response.status >= 400 && response.status < 500) {
                modelBDatapoint.endWithError(DatapointStatus.ClientError);
            } else {
                modelBDatapoint.endWithError(DatapointStatus.ServerError);
            }
        } else {
            modelBDatapoint.endWithError(DatapointStatus.ClientError);
        }
    } catch (e) {
        trace.errorThatWillCauseAlert(e);
        modelBDatapoint.endWithError(DatapointStatus.ClientError);
    }

    return false;
}
